import CaseStudies from "../../componentLayer/pages/CaseStudies";
import HomePage from "../../componentLayer/pages/Home/HomePage";
export const homeRouter = [
  {
    index: true,
    element: <HomePage />,
  },
  {
    path: "casestudies",
    element: <CaseStudies />,
  },

  // {
  //   path:"contact",
  //   index: true,
  //   element: <Contact />,
  // },
];
